import { EventLineType, ImportExportEventType } from "../constants"

// --------------------------------------------------------
// EXPORT
// --------------------------------------------------------

export const exportHandlerCat2Edito = {
  init: (chartObj) => {
    const cleanCols = chartObj.orderedCols.value.map(e => {
      const { columnId, columnIndex, ...others } = e
      return others
    })

    const state = {
      result: {
        ...chartObj.chartParameters.value,
        eventLines: [],
        columns: cleanCols,
        _cat2FormatVersion: 1,
      },
      eventLineMap: new Map()
    }

    return state
  },
  processEvent: (event, state, _chartObj) => {
    if (event.type === ImportExportEventType.EventLine) {
      const { eventLineId, ...others } = event.value
      others.notes = []
      state.result.eventLines.push(others)
      state.eventLineMap.set(eventLineId, others)

    } else if (event.type === ImportExportEventType.Note) {
      const { noteId, beat, column, eventLine, ...others } = event.value
      state.eventLineMap.get(eventLine.eventLineId).notes.push({ ...others, columnIndex: column.columnIndex })
    }

  },
  finally: (state, _chartObj) => {
    return JSON.stringify(state.result)
  }
}

// --------------------------------------------------------
// IMPORT 
// --------------------------------------------------------

export function importFunctionCat2Edito(chartObj, dataStr) {
  const dataObj = JSON.parse(dataStr)
  const func = upgradeVersionFuncs[dataObj._cat2FormatVersion ?? 0]

  if (func == null) {
    throw new Error(`Error: provided _cat2FormatVersion was an invalid value: ${dataObj._cat2FormatVersion}`)
  }
  func(chartObj, dataObj)
}


// --------------------------------------------------------
// VERSIONS 
// --------------------------------------------------------

const upgradeVersionFuncs = {
  1: (chartObj, dataObj) => {
    const { eventLines, columns, ...other } = dataObj

    for (const [k, v] of Object.entries(other))
      chartObj.setChartParameter(k, v)

    for (let i = 0; i < columns.length; i++) {
      let col = chartObj.orderedCols.value[i]
      if (col == null) col = chartObj.addChartColumn()

      for (const [k, v] of Object.entries(columns[i]))
        chartObj.setColumnParameter(col.columnId, k, v)
    }

    const existingEventLines = chartObj.eventLines.value.values()
    for (let i = 0; i < eventLines.length; i++) {
      const { time, notes, ...other } = eventLines[i]

      let eventLine = existingEventLines.find(e => e.time == time)
      if (eventLine == null) eventLine = chartObj.addEventLine(time, other.type, other)
      else {
        for (const [k, v] of Object.entries(other))
          chartObj.setEventLineParameter(eventLine.eventLineId, k, v)
      }

      if (Array.isArray(notes)) {
        for (const note of notes) {
          const { columnIndex, numerator, denominator, ...other } = note
          chartObj.addNote(eventLine, columnIndex, numerator, denominator, other)
        }
      }
    }
  },
  0: (chartObj, dataObj) => {
    const { controlLines, columnCount, bookmarks, ...other } = dataObj

    const newDataObj = { ...other, eventLines: [], columns: [] }

    bookmarks.forEach(e => {
      const { time, colour, thickness, ...other } = e
      newDataObj.eventLines.push({
        ...other, colour, time, thickness, type: EventLineType.Generic
      })
    })

    for (const cl of controlLines) {
      const { time, bpm, columns: d_columns, ...clOther } = cl
      const clObj = { ...clOther, time, bpm, type: EventLineType.Timing, notes: [] }
      newDataObj.eventLines.push(clObj)
      let columnIndex = 0
      for (const col of d_columns) {
        const { notes: d_notes, ...colOther } = col

        if (newDataObj.columns[columnIndex] == null) {
          newDataObj.columns[columnIndex] = { ...colOther }
        }

        for (const n of d_notes) {
          const { numerator, denominator, ...noteOther } = n
          clObj.notes.push({ ...noteOther, numerator, denominator, columnIndex })
        }
        columnIndex++
      }

    }
    upgradeVersionFuncs[1](chartObj, newDataObj)
  }
}